import { render } from "./MagicButton.ce.vue?vue&type=template&id=0dc6576e"
import script from "./MagicButton.ce.vue?vue&type=script&lang=js"
export * from "./MagicButton.ce.vue?vue&type=script&lang=js"

import _style_0 from "./MagicButton.ce.vue?vue&type=style&index=0&id=0dc6576e&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__